import { scienceblue, white } from '../colors';
export var MuiListItem = {
    styleOverrides: {
        root: {
            minHeight: 32,
            '&[class*=Mui-selected]': {
                backgroundColor: scienceblue,
                color: white,
            },
        },
        dense: {
            minHeight: 28,
        },
    },
};
